import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";
import { userLoginURL as userLoginURLAPi } from "../../../helpers/custom_helper/backend_helper";

// User Login Thunk
export const userLoginThunk = createAsyncThunk("auth/login",async (userData, { rejectWithValue }) => {
    try {
      const response = await userLoginURLAPi(userData);
      if (response.success) {
        const expiryTime = new Date().getTime() + 12 * 60 * 60 * 1000; // 12 hours

        localStorage.setItem("authToken", response.data.accessToken);
        localStorage.setItem("authUser", JSON.stringify(response.data));
        localStorage.setItem("authExpiry", expiryTime); 
        localStorage.setItem('authVersion', Date.now());

        return response.data;
      } else {
        toast.error(response.message || "Login failed");
        return rejectWithValue(response.message);
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || "Something went wrong";
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);
